<template>
  <ParseForm :formParams='formParams' :reMountPage='reMountPage' ref='bus' :opCode='opCode' :funcOnChange="bindAreaFlag" :funcKeyUp='bindKeyUpInterface'></ParseForm>
</template>

<script>
import ParseForm from '../../util/parseFormNew/ParseForm';
import conmmonJS from '../common';

export default {
  name: 'U_BaseBusiness',
  components: {
    ParseForm
  },
  mixins: [conmmonJS],
  props: [
    'formParams',
    'reMountPage',
    'opCode'
  ],
  data() {
    return {
      funcKeyUpMap: ''
    };
  },
  computed: {
    bindAreaFlag() {
      const $this = this;
      const resMap = new Map();
      resMap.set('grouptype', () => {
        if ($this.$refs.bus.getAttrByName('grouptype', 'value') === 2) {
          if ($this.$refs.bus.getAttrByName('areaFlag', 'value') === 0) {
            this.$toast('warning',this.$t('MCS.nozonegrp'));
          }
        }
      });
      resMap.set('areaFlag', () => {
        if ($this.$refs.bus.getAttrByName('areaFlag', 'value') === 0) {
          if ($this.$refs.bus.getAttrByName('grouptype', 'value') === 2) {
            this.$toast('warning',this.$t('MCS.nozonegrp'));
          }
        }
      });
      return resMap;
    },
    bindKeyUpInterface() {
      this.funcKeyUpMap = new Map();
      this.bindUtf8CodeLengthRegex('groupalias', 63);
      this.bindUtf8CodeLengthRegex('groupowner', 63);
      return this.funcKeyUpMap;
    },
  },
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },

    validateResult() {
      return this.$refs.bus.validateResult();
    },

    bindUtf8CodeLengthRegex(name, maxLength) {
      const $this = this;
      this.funcKeyUpMap.set(name, () => {
        const _rule = {
          regex: [$this.regex.char, $this.$t('MCS.noSpecialChar')]
        };
        $this.$refs.bus.removeValidate(name);
        $this.$refs.bus.setValidate(name, _rule);
        if ($this.$refs.bus.validateResult([name]) === true) {
          if ($this.utf8Length($this.$refs.bus.getDatas().get(name), maxLength) === false) {
            const _utf8Rule = {
              regex: [$this.regex.noMatchRegex, this.$t('MCS.charAt63')]
            };
            $this.$refs.bus.removeValidate(name);
            $this.$refs.bus.setValidate(name, _utf8Rule);
          }
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
